"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const HttpClient_1 = __importDefault(require("../../http/HttpClient"));
class Api {
    /**
     *
     * @param {} auth
     */
    constructor(auth) {
        this.auth = auth;
        /**
         * Set the header
         */
        this.headers = { Authorization: `OAuth2 ${auth.access_token}` };
    }
    /**
     * Handling the request object and authorization header to be send with the API
     * @param requestParam
     * @param requestObj
     * @returns
     */
    _httpRequest(requestObj) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new HttpClient_1.default(Object.assign(Object.assign({}, requestObj), { headers: this.headers })).call();
        });
    }
}
exports.default = Api;
